export const DISCOUNTS_TYPES = {
  PERCENTAGE: 'percentage',
  DISCOUNT: 'discount',
};

export enum DiscountEntityType {
  INVOICE = 'invoice',
  CUSTOMER = 'customer',
  CODE = 'code',
}
